import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { openLink, format, formatNumber, format_my } from '../Utils';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Table, TableHead, TableRow, TableCell, Typography, Grid, Paper, TableBody, Fade, CircularProgress, IconButton, Icon, Button, Tooltip, TextField, FormHelperText, InputAdornment } from '@material-ui/core';
import XLSX from 'xlsx';
import MomentUtils from '@date-io/moment';
import { ReportService } from '../Services/ReportService';
import Config from "../Config";
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3),
        overflow: 'auto'
    },
    formControl: {
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
        },
    },
    button: {
        marginBottom: theme.spacing(3),
        height: 58
    },
  })
);

function StoreEarning(props) {
    const classes = useStyles();
    const [selectedDate, handleDateChange] = useState(moment());
    const [fetch, setFetch] = useState(false);
    const [data, setData] = useState([]);
    const [threshold, setThreshold] = useState('');
    const [template, setTemplate] = useState('');
    const [rows, setRows] = useState([]);

    const sendMessage = (template, report) => e => {
        let message = template.replace(/\n/g, '%0a').replace('{{MonthYear}}', selectedDate.format(format_my)).replace('{{turnover}}', formatNumber(report.total_amount, 0)).replace('{{earned}}', formatNumber(report.commission, 0));
        if(report.mobile_no){
            let mobile = report.mobile_no
            if(!report.mobile_no.startsWith('91')){
                mobile = '91'+report.mobile_no;
            }
            openLink(`${Config.whatsapp_link.replace('{{mobile}}', mobile)}${message}`)
        }
    };

    function fallbackCopyTextToClipboard(text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        
        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";
      
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
      
        try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'successful' : 'unsuccessful';
          console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
          console.error('Fallback: Oops, unable to copy', err);
        }
      
        document.body.removeChild(textArea);
      }

    const copyToClipBoard = (template, report) => e => {
        console.log(template);
        let messageOrg = template.replace('{{MonthYear}}', selectedDate.format(format_my)).replace('{{turnover}}', formatNumber(report.total_amount, 0)).replace('{{earned}}', formatNumber(report.commission, 0));
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(messageOrg);
            return;
        }
        navigator.clipboard.writeText(messageOrg);
        props.showSnackBar('Message Copied', 'info');
    };

    useEffect(() => {
        props.setTitle('Store Earning Report');
        return () => {
            props.setTitle('') 
        }
    }, []);

    useEffect(() => {
        if(fetch){
            setRows([1,2,3,4,5, 6, 7, 8, 9, 10]
                .map(index => 
                        <TableRow key={index}>
                            <TableCell padding="none">
                                <Skeleton key={index} width="100%" height={70} />
                            </TableCell>
                            <TableCell padding="none">
                                <Skeleton key={index} width="100%" height={70}  />
                            </TableCell>
                            <TableCell padding="none" align="right">
                                <Skeleton key={index} width="100%" height={70}  />
                            </TableCell>
                            <TableCell padding="none" align="right">
                                <Skeleton key={index} width="100%" height={70}  />
                            </TableCell>
                            <TableCell padding="none" align="right">
                                <Skeleton key={index} width="100%" height={70}  />
                            </TableCell>
                            <TableCell padding="none" align="right">
                                <Skeleton key={index} width="100%" height={70}  />
                            </TableCell>
                        </TableRow>
                ));
            props.isLoading(true);
            setFetch(false);
            ReportService.getStoreEarning(moment(selectedDate).startOf('d').startOf('month').format(format), moment(selectedDate).startOf('d').endOf('month').format(format))
            .then((data) => {
                console.log(data);
                setData(data.report);
                setThreshold(data.threshold);
                setTemplate(data.template);
                let rows = [];
                data.report.forEach((report, index) => {
                    rows.push(
                        <TableRow key={index}>
                            <TableCell padding="none">
                                <Typography variant="subtitle1" color="textPrimary">{index + 1}</Typography>
                            </TableCell>
                            <TableCell padding="none">
                                <Typography variant="subtitle1" color="textPrimary">{report.store}</Typography>
                            </TableCell>
                            <TableCell padding="none" align="right">
                                <Typography variant="subtitle1" color="textPrimary">{report.mobile_no}</Typography>
                            </TableCell>
                            <TableCell padding="none" align="right">
                                <Typography variant="subtitle1" color="textPrimary">{formatNumber(report.total_amount, 0)}</Typography>
                            </TableCell>
                            <TableCell padding="none" align="right">
                                <Typography variant="subtitle1" color="textPrimary">{formatNumber(report.commission, 0)}</Typography>
                            </TableCell>
                            <TableCell padding="none" align="right">
                                <Tooltip title={'click to Copy'}>
                                    <IconButton 
                                        onClick={copyToClipBoard(data.template, report)}>
                                        <Icon>note</Icon>
                                    </IconButton>
                                </Tooltip>
                                <IconButton 
                                    disabled={report.mobile_no && report.mobile_no.length < 10}
                                    onClick={sendMessage(data.template, report)}>
                                    <Icon>send</Icon>
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    );
                });
                setRows(rows);
                props.isLoading(false);
            })
            .catch((error) => {
                props.isLoading(false);
            });
        }
    }, [fetch]);

    const exportReport = () => {
        if(data && data.length > 0){
            let sheetname = 'Store Earning Report';
            let exportData = [];
            let title = ["Sl No", "Store", "Mobile", "Turnover", "Earning"];
            exportData.push(title);
            data.forEach((d, index) => {
                let row = [index + 1, d.store, d.mobile_no, parseFloat(d.total_amount), parseFloat(d.commission)];
                exportData.push(row);
            });

            if(exportData){
                const wb = XLSX.utils.book_new();
                const wsAll = XLSX.utils.aoa_to_sheet(exportData);
                XLSX.utils.book_append_sheet(wb, wsAll, sheetname );
                XLSX.writeFile(wb, sheetname + ".xlsx");
            }
        } else {
            props.showSnackBar('Nothing to export', 'error');
        }
    }

    const saveTemplate = () => {
        let body = {
            template, 
            criteria: threshold, 
            category: 'STORE',
            type: 'EARNING'
        };
        console.log(body);
        ReportService.saveTemplate(body)
        .then(data => {
            if(data.status) {
                setFetch(true);
                props.showSnackBar('Saved template. Refetching data', 'info');
            }
        })

    }

    return (
        <div className="Home">
				<div className="">
				<Grid container spacing={2} style={{marginTop: 20}}>
                    <Grid item lg={12} xs={12}>
                        <Paper className={classes.root}>
                            {/* <Typography variant="h6">View Indents</Typography> */}
                            <Grid container alignItems="center" justify="flex-start" spacing={2}>
                                <Grid item xs={12} lg={2}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            variant="inline"
                                            inputVariant="outlined"
                                            views={["year", "month"]}
                                            label="Choose Year and Month"
                                            helperText="Start from year selection"
                                            maxDate={moment().endOf('month')}
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={12} lg={2}>
                                    <Button
                                        size="large"
                                        variant="contained"
                                        color="primary"
                                        onClick={(e) => setFetch(true)}
                                        className={classes.button}>
                                        Generate Report
                                    </Button>
                                </Grid>
                                <Grid item xs={12} lg={7}>
                                </Grid>
                                <Grid item xs={12} lg={1}>
                                    <IconButton color="inherit" onClick={(e) => exportReport()}>
                                        <Icon>save_alt</Icon>
                                    </IconButton>
                                </Grid>
                            </Grid>
                            </Paper>
                        </Grid>
                        <Grid item lg={12} xs={12}>
                            {   
                                template && (
                                    <Paper className={classes.root}>
                                        <Grid container item xs={12} lg={12} alignItems="flex-start">
                                            <Grid item lg={6}>
                                                <TextField
                                                    fullWidth
                                                    id="outlined-multiline-static"
                                                    label="Message template"
                                                    multiline
                                                    rows={10}
                                                    value={template}
                                                    onChange={(e) => {
                                                        setTemplate(e.target.value);
                                                    }}
                                                    variant="outlined"
                                                    />
                                                <FormHelperText>{`Do not remove the fields {{MonthYear}}, {{earned}} and {{turnover}}`}</FormHelperText>
                                            </Grid>
                                            <Grid item lg={2}>
                                                <TextField
                                                    label="Threshold"
                                                    id="outlined-start-adornment"
                                                    className={classes.formControl}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start">INR</InputAdornment>,
                                                    }}
                                                    fullWidth
                                                    variant="outlined"
                                                    value={threshold}
                                                    onChange={(e) => setThreshold(e.target.value)}
                                                    />
                                                <Button
                                                    style={{marginTop: 16, marginLeft: 16, marginRight: 8}}
                                                    variant="contained"
                                                    color="primary"
                                                    fullWidth
                                                    className={classes.button}
                                                    onClick={(e) => saveTemplate()}>
                                                    Save
                                                </Button>
                                            </Grid>
                                            <Grid item lg={2}>
                                                
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                )
                            }
                        </Grid>
                        <Grid item lg={12} xs={12}>
                            <Paper className={classes.root}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="h6" color="textPrimary">Store</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="h6" color="textPrimary">Mobile</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="h6" color="textPrimary">Turnover</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="h6" color="textPrimary">Earnings</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows}
                                    </TableBody>
                                </Table>
                                <Fade
                                    in={fetch}
                                    style={{
                                        transitionDelay: fetch ? '10ms' : '0ms'
                                    }}
                                    unmountOnExit
                                    >
                                    <CircularProgress style={{marginTop: 20}}/>
                                </Fade>
                            </Paper>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
};

export default StoreEarning;